import { render, staticRenderFns } from "./AddAuthorizationLayout.vue?vue&type=template&id=1cb3f9d0&scoped=true"
import script from "./AddAuthorizationLayout.vue?vue&type=script&lang=js"
export * from "./AddAuthorizationLayout.vue?vue&type=script&lang=js"
import style0 from "./AddAuthorizationLayout.vue?vue&type=style&index=0&id=1cb3f9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3f9d0",
  null
  
)

export default component.exports